import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import cancellationPolicyService from '../services/cancellationPolicyService'
import PolicyDisplay from '../components/PolicyDisplay'
import Loader from '../components/Loader'

/**
 * Standalone public page for the active Terms & Conditions version.
 * Linked from Footer / Register and crawlable.
 */
const TermsAndConditions = () => {
  const [policy, setPolicy] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    cancellationPolicyService
      .getActive('terms_and_conditions')
      .then((resp) => {
        if (!cancelled) setPolicy(resp?.policy || null)
      })
      .catch((err) => {
        console.error('terms_load_error', err)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="container mx-auto max-w-3xl px-4 py-8">
      <Helmet>
        <title>Terms &amp; Conditions · Himyatra</title>
        <meta
          name="description"
          content="The terms and conditions governing the use of Himyatra services and bookings."
        />
      </Helmet>
      <h1 className="mb-6 text-3xl font-bold text-gray-900">Terms &amp; Conditions</h1>
      {loading ? (
        <Loader />
      ) : (
        <PolicyDisplay
          policy={policy}
          title="Terms & Conditions"
          defaultOpen
          proseSize="prose-base"
        />
      )}
      {policy && (
        <p className="mt-4 text-xs text-gray-500">
          Version <span className="font-mono">{policy.version}</span>
        </p>
      )}
    </div>
  )
}

export default TermsAndConditions
